// extracted by mini-css-extract-plugin
export var hero_container = "index-module--hero_container--HZ6ER";
export var hero_wrapper = "index-module--hero_wrapper--w+00y";
export var text_container = "index-module--text_container--eKmFo";